module.exports = __webpack_public_path__ + "img/zip.aebd301.svg";